import { render, staticRenderFns } from "./startTestTotal.vue?vue&type=template&id=cd570024&scoped=true"
import script from "./startTestTotal.vue?vue&type=script&lang=js"
export * from "./startTestTotal.vue?vue&type=script&lang=js"
import style0 from "./startTestTotal.vue?vue&type=style&index=0&id=cd570024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd570024",
  null
  
)

export default component.exports